export default [
  // {
  //   id: 'A',
  //   type: 'tower',
  //   level: '2',
  //   studio: true,
  //   bath: 1,
  //   interior: 381,
  // },
  // {
  //   id: 'A1',
  //   type: 'tower',
  //   level: '2',
  //   studio: true,
  //   bath: 1,
  //   interior: 401,
  // },
  // {
  //   id: 'B',
  //   type: 'tower',
  //   level: '3-10',
  //   bed: 1,
  //   bath: 1,
  //   interior: 588,
  //   exterior: 108,
  // },
  // {
  //   id: 'C',
  //   type: 'tower',
  //   level: '3-10',
  //   bed: 1,
  //   bath: 1,
  //   interior: 623,
  //   exterior: 108,
  // },
  // {
  //   id: 'D',
  //   type: 'tower',
  //   level: '2',
  //   bed: 1,
  //   bath: 1,
  //   den: true,
  //   interior: 676,
  //   exterior: 108,
  // },
  {
    id: 'E',
    type: 'tower',
    level: '2-21',
    bed: 2,
    bath: 2,
    interior: 751,
    exterior: 73,
  },
  {
    id: 'F',
    type: 'tower',
    level: '2-21',
    bed: 2,
    bath: 2,
    interior: 774,
    exterior: 73,
  },
  {
    id: 'G',
    type: 'tower',
    level: '3-21',
    bed: 2,
    bath: 2,
    den: true,
    interior: 870,
    exterior: 107,
  },
  // {
  //   id: 'H',
  //   type: 'tower',
  //   level: '11-21',
  //   bed: 2,
  //   bath: 2,
  //   interior: 956,
  //   exterior: 108,
  // },
  // {
  //   id: 'I',
  //   type: 'tower',
  //   level: '1',
  //   bed: 1,
  //   bath: 1,
  //   den: true,
  //   interior: 686,
  //   exterior: 247,
  // },
  // {
  //   id: 'J',
  //   type: 'tower',
  //   level: '3-10',
  //   bed: 2,
  //   bath: 2,
  //   interior: 1008,
  //   exterior: 161,
  // },
  // {
  //   id: 'J1',
  //   type: 'tower',
  //   level: '3-10',
  //   bed: 1,
  //   bath: 1,
  //   interior: 580,
  //   exterior: 106,
  // },
  // {
  //   id: 'K',
  //   type: 'tower',
  //   level: '3-21',
  //   bed: 2,
  //   bath: 2,
  //   interior: 1019,
  //   exterior: 107,
  // },
  // {
  //   id: 'L',
  //   type: 'tower',
  //   level: '1',
  //   bed: 2,
  //   bath: 2,
  //   interior: 1040,
  //   exterior: 275,
  // },
  // {
  //   id: 'M',
  //   type: 'tower',
  //   level: '2-21',
  //   bed: 2,
  //   bath: 2,
  //   den: true,
  //   interior: 1075,
  //   exterior: 110,
  // },
  // {
  //   id: 'N',
  //   type: 'tower',
  //   level: '2',
  //   bed: 2,
  //   bath: 2.5,
  //   den: true,
  //   interior: 1169,
  //   exterior: 109,
  // },
  // {
  //   id: 'P',
  //   type: 'tower',
  //   level: '2-21',
  //   bed: 3,
  //   bath: 3,
  //   interior: '1164-1174',
  //   exterior: 108,
  //   areaRange: '1272 - 1282',
  // },
  // {
  //   id: 'PH1',
  //   type: 'tower',
  //   level: '22',
  //   bed: 3,
  //   bath: 3,
  //   den: true,
  //   interior: 1963,
  //   exterior: 625,
  // },
  // {
  //   id: 'PH2',
  //   type: 'tower',
  //   level: '22',
  //   bed: 3,
  //   bath: 2,
  //   den: true,
  //   interior: 1341,
  //   exterior: 146,
  // },
  // {
  //   id: 'PH3',
  //   type: 'tower',
  //   level: '22',
  //   bed: 3,
  //   bath: 3,
  //   den: true,
  //   interior: 1490,
  //   exterior: 988,
  // },
  // {
  //   id: 'PH4',
  //   type: 'tower',
  //   level: '22',
  //   bed: 3,
  //   bath: 3,
  //   den: true,
  //   interior: 1414,
  //   exterior: 784,
  // },
  // {
  //   id: 'R',
  //   type: 'tower',
  //   level: '12-21',
  //   bed: 3,
  //   bath: 3,
  //   interior: 1343,
  //   exterior: 275,
  // },
  // {
  //   id: 'R1',
  //   type: 'tower',
  //   level: '11',
  //   bed: 3,
  //   bath: 3,
  //   interior: 1343,
  //   exterior: 275,
  // },
  // {
  //   id: 'S',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 1,
  //   bath: 1,
  //   interior: 483,
  //   exterior: 24,
  // },
  // {
  //   id: 'T',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 1,
  //   bath: 1,
  //   interior: '533-564',
  //   exterior: '24-48',
  //   areaRange: '577 - 612',
  // },
  // {
  //   id: 'TH',
  //   type: 'townhome',
  //   level: 'P1, 1-3',
  //   bed: 3,
  //   bath: 2.5,
  //   den: true,
  //   interior: '1902-1919',
  // },
  // {
  //   id: 'TH-W',
  //   type: 'townhome',
  //   level: 'P1, 1-3',
  //   bed: 3,
  //   bath: 2.5,
  //   den: true,
  //   interior: '1918',
  //   pdf: 'th-w',
  // },
  // {
  //   id: 'TH-E',
  //   type: 'townhome',
  //   level: 'P1, 1-3',
  //   bed: 3,
  //   bath: 2.5,
  //   den: true,
  //   interior: '1915',
  //   pdf: 'th-e',
  // },
  {
    id: 'T1',
    type: 'mid-rise',
    level: '2-4',
    bed: 1,
    bath: 1,
    interior: '553-564',
    exterior: '24-48',
  },
  // {
  //   id: 'U',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 2,
  //   bath: 2,
  //   interior: 761,
  //   exterior: 48,
  // },
  // {
  //   id: 'V',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 2,
  //   bath: 2,
  //   interior: 778,
  //   exterior: 48,
  // },
  // {
  //   id: 'W',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 2,
  //   bath: 2,
  //   interior: 886,
  // },
  // {
  //   id: 'X',
  //   type: 'mid-rise',
  //   level: '2-4',
  //   bed: 2,
  //   bath: 2,
  //   interior: 850,
  // },
  {
    id: 'Y',
    type: 'mid-rise',
    level: '2-4',
    bed: 2,
    bath: 2,
    interior: 807,
  },
];



// WEBPACK FOOTER //
// ./src/data/plans.js